export default "__VITE_ASSET__404cccb8__"